var render = function render(){
  var _vm$rules$_vm$COMPANY;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-form', {
    staticClass: "pa-16",
    model: {
      value: _vm.isValid,
      callback: function ($$v) {
        _vm.isValid = $$v;
      },
      expression: "isValid"
    }
  }, [_c('vertical-form-table', {
    attrs: {
      "items": _vm.items1
    },
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.inputs,
      callback: function ($$v) {
        _vm.inputs = $$v;
      },
      expression: "inputs"
    }
  }, [_c('template', {
    slot: "비밀번호 확인"
  }, [_c('v-password-confirm-field', {
    attrs: {
      "password": _vm.inputs.password,
      "outlined": ""
    },
    model: {
      value: _vm.isPasswordConfirmed,
      callback: function ($$v) {
        _vm.isPasswordConfirmed = $$v;
      },
      expression: "isPasswordConfirmed"
    }
  })], 1), _c('template', {
    slot: "연락처"
  }, [_c('user-contact-certification', {
    attrs: {
      "outlined": "",
      "dense": "",
      "btnAttrs": {
        color: 'grey-6 white--text',
        className: 'w-80px w-lg-100px mt-n8'
      }
    },
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.inputs.phone,
      callback: function ($$v) {
        _vm.$set(_vm.inputs, "phone", $$v);
      },
      expression: "inputs.phone"
    }
  })], 1)], 2), _c('h5', {
    staticClass: "page-text page-text--lg grey-13--text mb-12 mt-40"
  }, [_vm._v("기업정보입력")]), _c('vertical-form-table', {
    attrs: {
      "items": _vm.items2
    },
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.inputs,
      callback: function ($$v) {
        _vm.inputs = $$v;
      },
      expression: "inputs"
    }
  }, [_c('template', {
    slot: "사업자등록증"
  }, [_c('v-file-input', {
    attrs: {
      "outlined": "",
      "dense": "",
      "prepend-icon": null,
      "prepend-inner-icon": "mdi-file-upload-outline",
      "rules": (_vm$rules$_vm$COMPANY = _vm.rules[_vm.COMPANY.value]) === null || _vm$rules$_vm$COMPANY === void 0 ? void 0 : _vm$rules$_vm$COMPANY.businessRegistration
    },
    on: {
      "change": _vm.emit
    },
    model: {
      value: _vm.inputs.businessRegistration,
      callback: function ($$v) {
        _vm.$set(_vm.inputs, "businessRegistration", $$v);
      },
      expression: "inputs.businessRegistration"
    }
  })], 1), _c('template', {
    slot: "주소"
  }, [_c('v-address-field', {
    attrs: {
      "outlined": "",
      "dense": "",
      "btnAttrs": {
        color: 'grey-6 white--text',
        className: 'w-80px w-lg-100px mt-n8'
      }
    },
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.inputs,
      callback: function ($$v) {
        _vm.inputs = $$v;
      },
      expression: "inputs"
    }
  })], 1)], 2), _c('terms-of-agreements-short', {
    on: {
      "isValid": function (isValid) {
        return _vm.isTermsValid = isValid;
      },
      "input": _vm.emit
    },
    model: {
      value: _vm.inputs._terms,
      callback: function ($$v) {
        _vm.$set(_vm.inputs, "_terms", $$v);
      },
      expression: "inputs._terms"
    }
  }), _c('div', {
    staticClass: "v-btn-group"
  }, [_c('v-btn', {
    staticClass: "min-w-140px min-w-lg-160px",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.join
    }
  }, [_c('span', [_vm._v("가입하기")])])], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }